var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h2',{staticClass:"vb-heading h5"},[_vm._v("I voli inclusi")]),_vm._l((_vm.flights),function(flight,flight_index){return _c('div',{key:flight + flight_index},_vm._l((flight.segments),function(segment,segment_index){return _c('div',{key:segment + segment_index},_vm._l((segment.routes),function(route,route_index){return _c('div',{key:route + route_index},[_c('div',{staticClass:"vb-flights"},[_c('div',{staticClass:"vb-flights__date"},[_c('vb-icon',{class:flight_index === _vm.flights.length - 1
                  ? 'vb-flights__date-icon vb-flights__date-icon--reverse'
                  : 'vb-flights__date-icon',attrs:{"name":'airplane',"size":20,"color":_vm.sass('primary')}}),_c('span',{staticClass:"vb-flights__date-text",domProps:{"innerHTML":_vm._s(
                _vm.parse_date(route.departureDateTime.split(' ')[0]).day_number +
                ' ' +
                _vm.parse_date(route.departureDateTime.split(' ')[0])
                  .month_string +
                ' ' +
                _vm.parse_date(route.departureDateTime.split(' ')[0]).year
              )}})],1),_c('div',{staticClass:"vb-flights__info"},[_c('span',{domProps:{"innerHTML":_vm._s(
                'Partenza da ' +
                '<span class=\'text-capitalize\'>' +
                route.departureAirportName.toLowerCase() +
                '</span>' +
                ' (' +
                route.departureAirportId +
                ')'
              )}}),_c('span',{domProps:{"innerHTML":_vm._s(
                ' alle ' + route.departureDateTime.split(' ')[1].slice(0, 5)
              )}}),_vm._v(", "),_c('span',{domProps:{"innerHTML":_vm._s(
                ' arrivo a ' +
                '<span class=\'text-capitalize\'>' +
                route.arrivalAirportName.toLowerCase() +
                '</span>' +
                ' (' +
                route.arrivalAirportId +
                ')'
              )}}),_c('span',{domProps:{"innerHTML":_vm._s(
                ' alle ' + route.arrivalDateTime.split(' ')[1].slice(0, 5)
              )}}),(
                route.arrivalDateTime.split(' ')[0] !==
                route.departureDateTime.split(' ')[0]
              )?_c('span',{domProps:{"innerHTML":_vm._s(' (+1)')}}):_vm._e(),_c('span',{domProps:{"innerHTML":_vm._s(' - Compagnia ' + route.operatingCarrier)}}),_c('span',{domProps:{"innerHTML":_vm._s(' - Classe ' + route.classType)}})])])])}),0)}),0)}),_c('disclaimer-flights-info')],2)
}
var staticRenderFns = []

export { render, staticRenderFns }